// import { motion } from "framer-motion";

// export default function AboutUs() {
//   return (
//     <section className="font-inter py-24 bg-white">
//       <div className="max-w-7xl mx-auto px-6">
//         <div className="grid lg:grid-cols-2 gap-16 items-center">
//           {/* Left – Image */}
//           <motion.div
//             initial={{ opacity: 0, x: -40 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.7 }}
//             viewport={{ once: true }}
//             className="relative"
//           >
//             <img
//               src="https://i.pinimg.com/1200x/9d/67/6e/9d676e1e3e5a0380b6616cca724c5206.jpg"
//               alt="Infronex Team"
//               className="rounded-2xl shadow-xl object-cover w-full h-[420px]"
//             />

//           </motion.div>

//           {/* Right – Content */}
//           <motion.div
//             initial={{ opacity: 0, x: 40 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.7 }}
//             viewport={{ once: true }}
//           >
//             <h4 className="text-blue-600 font-semibold mb-3 tracking-wide uppercase">
//               About Infronex
//             </h4>

//             <h2 className="text-4xl font-bold text-gray-900 leading-tight mb-6">
//               We Build Technology That Powers Business Growth
//             </h2>

//             <p className="text-gray-600 text-lg mb-6 leading-relaxed">
//               Infronex is a technology-driven IT solutions company focused on
//               building scalable software, modern web platforms, and secure
//               digital systems for businesses across industries.
//             </p>

//             <p className="text-gray-600 text-lg mb-8 leading-relaxed">
//               Our team of experienced developers, designers and system
//               architects work together to transform your ideas into
//               high-performing digital products that deliver real business
//               results.
//             </p>

//             <div className="flex items-center gap-6">
//               <div>
//                 <p className="text-3xl font-bold text-gray-900">200+</p>
//                 <p className="text-sm text-gray-500">Projects Delivered</p>
//               </div>
//               <div>
//                 <p className="text-3xl font-bold text-gray-900">50+</p>
//                 <p className="text-sm text-gray-500">Global Clients</p>
//               </div>
//               <div>
//                 <p className="text-3xl font-bold text-gray-900">99%</p>
//                 <p className="text-sm text-gray-500">Client Satisfaction</p>
//               </div>
//             </div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// }

import { motion } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function AboutUs() {
  return (
    <section className="bg-white py-24 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* LEFT – VISUAL COMPOSITION */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="lg:col-span-6 relative"
          >
            {/* Main Image with professional grayscale/tint treatment */}
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl border border-slate-100">
              <img
                src="https://i.pinimg.com/1200x/9d/67/6e/9d676e1e3e5a0380b6616cca724c5206.jpg"
                alt="Infronex Strategy"
                className="w-full h-[500px] object-cover grayscale-[20%] hover:grayscale-0 transition-all duration-700"
              />
            </div>

            {/* Decorative Floating Element */}
            <div className="absolute -bottom-6 -right-6 z-20 bg-slate-900 text-white p-8 rounded-2xl shadow-xl hidden md:block max-w-[280px]">
              <p className="text-sm font-medium leading-relaxed opacity-90">
                "Our mission is to bridge the gap between complex challenges and
                elegant software solutions."
              </p>
              <div className="mt-4 flex items-center gap-2">
                <div className="h-px w-8 bg-indigo-500"></div>
                <span className="text-[10px] uppercase tracking-widest text-indigo-400 font-bold">
                  Infronex Vision
                </span>
              </div>
            </div>

            {/* Background Accent */}
            <div className="absolute -top-10 -left-10 w-64 h-64 bg-slate-50 rounded-full -z-0" />
          </motion.div>

          {/* RIGHT – CONTENT */}
          <motion.div
            className="lg:col-span-6"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-indigo-600"></span>
              <span className="text-xs font-bold tracking-[0.2em] text-indigo-600 uppercase">
                Enterprise Excellence
              </span>
            </div>

            <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 leading-tight mb-6">
              Engineering Technology That <br />
              <span className="text-slate-500 font-medium">
                Architects Business Growth
              </span>
            </h2>

            <div className="space-y-6">
              <p className="text-slate-600 text-[16px] leading-relaxed">
                Infronex is a technology-first consultancy specializing in
                high-availability software architectures. We don't just build
                apps; we engineer digital ecosystems that remain resilient as
                your business scales.
              </p>

              <p className="text-slate-600 text-[16px] leading-relaxed">
                By integrating AI-driven insights with robust cloud
                infrastructure, our team transforms legacy processes into modern
                competitive advantages.
              </p>
            </div>

            {/* Professional Value Grid instead of simple stats */}
            <div className="grid sm:grid-cols-2 gap-4 mt-10">
              {[
                "Scalable Cloud Architecture",
                "High-Performance Web Systems",
                "Enterprise Security Standards",
                "Agile Product Engineering",
              ].map((text, i) => (
                <div key={i} className="flex items-center gap-3">
                  <CheckCircle2
                    size={18}
                    className="text-indigo-600 flex-shrink-0"
                  />
                  <span className="text-sm font-semibold text-slate-800">
                    {text}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-12 pt-8 border-t border-slate-100 flex items-center gap-8">
              <button className="relative group px-6 py-3 bg-slate-50 border border-slate-200 rounded-2xl overflow-hidden transition-all duration-300 hover:border-indigo-600 hover:shadow-lg hover:shadow-indigo-500/10">
                {/* Background Hover Slide Effect */}
                <div className="absolute inset-0 bg-indigo-600 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" />

                <div className="relative flex items-center gap-3">
                  {/* Icon representing the technical roadmap */}
                  {/* <div className="w-8 h-8 rounded-lg bg-white border border-slate-100 flex items-center justify-center text-indigo-600 shadow-sm group-hover:rotate-12 transition-transform">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="m7 11 2-2-2-2" />
                      <path d="M11 19v-6a2 2 0 0 0-2-2H4" />
                      <path d="M15 5v6a2 2 0 0 0 2 2h5" />
                      <path d="m21 9-2 2 2 2" />
                    </svg>
                  </div> */}

                  <Link
                    to="/about"
                    className="group flex items-center gap-2 no-underline"
                  >
                    <span className="text-sm font-black uppercase tracking-widest text-slate-900 group-hover:text-white transition-colors duration-200">
                      Learn about our process
                    </span>

                    <span className="text-slate-400 group-hover:text-white group-hover:translate-x-1 transition-all duration-200">
                      ⟶
                    </span>
                  </Link>
                </div>
              </button>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}